import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import EndreMiljokontroll from "./EndreMiljokontroll";

import {
  getAllMiljoKontrollHistorikk,
  getMiljokontroll,
  getMiljokontroller,
} from "../../../../actions/miljokontrollerActions";
import { putStedbeskrivelse } from "../../../../actions/stedbesrkivelserActions";

export default function EndreMiljokontrollContainer() {
  const dispatch = useDispatch();
  const miljokontroll = useSelector((state) => state.miljokontroll);
  const miljokontrollOversiktFilterForm = useSelector(
    (state) => state.forms.miljokontrollOversiktFilterForm,
  );
  const putStedbeskrivelseAction = useCallback(
    (payload) =>
      dispatch(
        putStedbeskrivelse(
          miljokontroll.stedbeskrivelseId,
          {
            gateNavn: payload.gatenavn,
            gateNummer: payload.gatenummer,
            oppgang: payload.oppgang,
            bydel: payload.bydel,
            vedGate: payload.vedGate,
            vedGateNummer: payload.vedGatenummer,
            vedOppgang: payload.vedOppgang,
          },
          () => dispatch(getMiljokontroller(miljokontrollOversiktFilterForm)),
          () => dispatch(getMiljokontroll(miljokontroll.id)),
          () => dispatch(getAllMiljoKontrollHistorikk(miljokontroll.id)),
        ),
      ),
    [dispatch, miljokontroll, miljokontrollOversiktFilterForm],
  );

  return (
    <EndreMiljokontroll
      miljokontroll={miljokontroll}
      putStedbeskrivelse={putStedbeskrivelseAction}
    />
  );
}
